<mat-icon (click)="toggle()">{{icon}}</mat-icon>
